import {
  deletePayerData,
  getPayersList,
  ResetPayerId
} from '../actions';
import {
  Field,
  reduxForm,
  reset,
} from 'redux-form';
import { alertConfirmation, base64Encode, resetFiltersAndSorting } from '../../../actions/utilAction';
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import history from '../../../history';
import PaginatorCustom from '../../../components/paginationCustom';
import RaisedButton from 'material-ui/RaisedButton';
import { renderTextField } from '../../../components/reduxFields';
import SortingCustom from '../../../components/SortingCustom';

class ManagePayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      masterInsuranceType: [],
    };

    this.filter = {
      sort_Column: 'id',
      sort_Order: 'desc',
      searchText: '',
    };

    this.handleSearchPayerData = this.handleSearchPayerData.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
    this.handleAddPayer = this.handleAddPayer.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_Order || 'desc',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getPayersList(searchObj);
  }

  handleAddPayer = () => {
    this.props.ResetPayerId();
    history.push('/payer');
  };
  handleEditClick=(event, obj) => {
    let payerID = base64Encode(`${obj.id}`);
    history.push(`/payer/${payerID}`);
  };

  handleAlertClick=(event, payerID) => {
    event.preventDefault();
    this.props.deletePayerData(payerID);
    Alert.closeAll();
  };

  handleDeleteClick=(event, obj) => {
    event.preventDefault();
    alertConfirmation('Are you sure you want to delete this payer?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.postPayerData && this.props.postPayerData !== nextProps.postPayerData) {
      this.loadData();
    }
    if (nextProps.deletePayer && this.props.deletePayer !== nextProps.deletePayer) {
      this.loadData();
    }
  };

  handleSearchPayerData(event) {
    // event.preventDefault();
    if (event.Payer && event.Payer.trim()) {
      this.filter.searchText = event.Payer;
      this.loadData();
    }
  }
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleSearchChange(event) {
    if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
    if (event.target.value && event.target.value.length >= 3) {
      this.filter.searchText = event.target.value;
      this.loadData();
    }
  }

  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ManagePayerForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.loadData();
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadData();
    }
  }

  renderHeaders() {
    if (this.props.payerList !== undefined && this.props.payerList.length > 0) {
      return (
        <tr>
          {/* <th width="10%"><Sorting setSortColumn={this.setSortColumn} columnName='id' displayName='Payer Id'/></th>*/}
          <th width="32%"><SortingCustom setSortColumn={this.setSortColumn} columnName='name' displayName='Payer Name'/></th>
          <th width="18%"><SortingCustom setSortColumn={this.setSortColumn} columnName='email' displayName='Email'/></th>
          <th width="18%"><SortingCustom setSortColumn={this.setSortColumn} columnName='insType' displayName='Insurance Type'/></th>
          <th width="18%"><SortingCustom setSortColumn={this.setSortColumn} columnName='isActive' displayName='Status'/></th>
          {this.props.updatePermission || this.props.deletePermission ?
            <th width="15%"><span>Action</span></th>
            : null
          }
        </tr>
      );
    }
    else{
      return (
        <tr>
          {/* <th width="10%"><span>Payer Id</span></th>*/}
          <th width="32%"><span>Payer Name</span></th>
          <th width="18%"><span>Email</span></th>
          <th width="15%"><span>Insurance Type</span></th>
          <th width="10%"><span>Status</span></th>
          {this.props.updatePermission || this.props.deletePermission ?
            <th width="15%"><span>Action</span></th> : null}
        </tr>
      );
    }
  }

  renderPayerLists() {
    if (!this.props.payerList || !this.props.payerList.length) {
    //if (this.props.payerList !== undefined && this.props.payerList.length === 0) {
      return (
        <tr>
          <td colSpan="5">
            <div className="familydl text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }

    if (this.props.payerList !== undefined && this.props.payerList.length > 0) {
      return this.props.payerList.map((Obj, index) => {
        return (
          <tr key={index}>
            <td>{Obj.name}</td>
            <td>{Obj.email}</td>
            <td>{Obj.insType}</td>
            <td className = {Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive ? 'Active' : 'Inactive'}</td>
            {this.props.updatePermission || this.props.deletePermission ?
              <td>
                {this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null}
                {this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null}
              </td> : null}
          </tr>
        );
      });
    }
  }

  renderPagination() {
    if (this.props.payerList && this.props.payerList.length > 0) {
      return (
        this.props.metaData && this.props.metaData.totalPages ?
          <PaginatorCustom data={this.props.metaData} handlePageChange={(page_number) => this.loadData(page_number)} />
          : null
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        <h2 className="page_title">Manage Payer</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Payer" primary={true} onTouchTap={this.handleAddPayer} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchPayerData)}>
                        <Field
                          name="Payer"
                          floatingLabelText="Search"
                          maxLength = '15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton className="grey_btn" primary={true} onTouchTap={this.handleResetButton}>Reset</RaisedButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-20">
                  <table className={tableClass}>
                    <thead>
                      <tr>                     
                        <th width="32%"><SortingCustom setSortColumn={this.setSortColumn} columnName='name' displayName='Payer Name'/></th>
                        <th width="18%"><SortingCustom setSortColumn={this.setSortColumn} columnName='email' displayName='Email'/></th>
                        <th width="18%"><SortingCustom setSortColumn={this.setSortColumn} columnName='insType' displayName='Insurance Type'/></th>
                        <th width="18%"><SortingCustom setSortColumn={this.setSortColumn} columnName='isActive' displayName='Status'/></th>
                        {this.props.updatePermission || this.props.deletePermission ?
                          <th width="15%"><span>Action</span></th>
                          : null
                        }
                    </tr>
                    </thead>
                    <tbody>
                      {this.renderPayerLists()}
                    </tbody>
                  </table>
                  {this.renderPagination()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ManagePayer = reduxForm({
  form: 'ManagePayerForm',
})(ManagePayer);

function mapStateToProps(state) {
  let payerList = [], metaData = null;
  if (state.payer.get_payer_data && state.payer.get_payer_data.data) {
    payerList = state.payer.get_payer_data.data;
    metaData = state.payer.get_payer_data.meta;
  }
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'PAYER');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'PAYER_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'PAYER_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'PAYER_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'PAYER_LIST_DELETE')[0].permission : false;

  // End For Role Permission
  return {
    payerList: payerList,
    metaData: metaData,
    postPayerData: state.payer.save_payer_data,
    deletePayer: state.payer.delete_payer_data,
    loading: state.payer.loading,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}

export default connect(mapStateToProps, {
  getPayersList,
  deletePayerData,
  ResetPayerId })(ManagePayer);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/managePayer.js